import Barcode from "../Barcode.js";
class MSI extends Barcode {
  constructor(data, options) {
    super(data, options);
  }
  encode() {
    var ret = "110";
    for (var i = 0; i < this.data.length; i++) {
      var digit = parseInt(this.data[i]);
      var bin = digit.toString(2);
      bin = addZeroes(bin, 4 - bin.length);
      for (var b = 0; b < bin.length; b++) {
        ret += bin[b] == "0" ? "100" : "110";
      }
    }
    ret += "1001";
    return {
      data: ret,
      text: this.text
    };
  }
  valid() {
    return this.data.search(/^[0-9]+$/) !== -1;
  }
}
function addZeroes(number, n) {
  for (var i = 0; i < n; i++) {
    number = "0" + number;
  }
  return number;
}
var stdin_default = MSI;
export {
  stdin_default as default
};
